import "../../index31.css";
import { jsxs as C, jsx as r } from "react/jsx-runtime";
import { _ as c } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import R from "../Description/index.js";
import I from "../InlineLayout/index.js";
import L from "../InputError/index.js";
import N from "../InputLabel/index.js";
import k from "../ListView/index.js";
import q from "../../hooks/useSpacingToken.js";
const w = "_input-container_76lcn_1", T = "_input-section_76lcn_4", j = "_changed_76lcn_12", v = "_disabled_76lcn_18", z = "_errored_76lcn_26", A = "_general_76lcn_32", D = "_read-only_76lcn_39", e = {
  inputContainer: w,
  inputSection: T,
  changed: j,
  disabled: v,
  errored: z,
  general: A,
  readOnly: D
};
function Q(l) {
  const {
    containerRef: d,
    inputSectionRef: p,
    actions: m,
    className: f,
    disabled: t,
    error: n,
    errorOnTooltip: i = !1,
    hint: a,
    icons: u,
    input: _,
    label: g,
    readOnly: h,
    required: b,
    variant: s = "form",
    changed: y,
    withAsterisk: O,
    spacing: o
  } = l, S = O ?? b, x = q({
    spacing: o,
    offset: -3,
    // withAdditionalInlinePadding: true,
    modes: ["padding-inline"]
  });
  return /* @__PURE__ */ C(
    k,
    {
      elementRef: d,
      layout: "block",
      className: c(
        e.inputContainer,
        !!n && e.errored,
        h && e.readOnly,
        s === "form" && e.form,
        s === "general" && e.general,
        t && e.disabled,
        y && e.changed,
        f
      ),
      title: i && n && typeof n == "string" ? n : void 0,
      spacing: o,
      spacingOffset: -4,
      children: [
        /* @__PURE__ */ r(
          N,
          {
            disabled: t,
            required: S,
            children: g
          }
        ),
        /* @__PURE__ */ r(
          I,
          {
            className: c(
              e.inputSection,
              x
            ),
            elementRef: p,
            before: u,
            after: m,
            spacingOffset: -3,
            spacing: o,
            children: _
          }
        ),
        !n && !i && a && /* @__PURE__ */ r(
          R,
          {
            withLightText: !0,
            textSize: "sm",
            children: a
          }
        ),
        n && /* @__PURE__ */ r(
          L,
          {
            disabled: t,
            floating: i,
            children: n
          }
        )
      ]
    }
  );
}
export {
  Q as default
};
